import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CatalogueCode, Category, Code, CodeType, CodeUoM, GetCodeCategoryEntitiesRequest, UoM } from '@jms/model';
import { ICodePickerService } from '@jms/ui/ui.code.picker.pro';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class CodePickerService implements ICodePickerService {

    private readonly apiPath = '/api/codes/';
    private readonly pickerAPI = '/api/picker/';
    private readonly categoriesAPI = '/api/categories/';


    constructor(
        private http: HttpClient
    ) { }

    public loadCategories(purchaseAble?: boolean): Observable<Category[]> {
        return this.http.get<Category[]>(`${this.apiPath}categories`, {
            params: purchaseAble ? { itemPurchased: 'true' } : null
        });
    }

    public loadCategoriesV2(): Observable<Category[]> {
        return this.http.get<Category[]>(`${this.apiPath}categories/v2`);
    }

    public loadUoMs(): Observable<UoM[]> {
        return this.http.get<UoM[]>(this.pickerAPI + 'uom');
    }

    public loadCodePickerDetails(codeId: string): Observable<CatalogueCode[]> {
        return this.http.get<CatalogueCode[]>(this.apiPath + 'code/' + codeId);
    }


    public loadCodesDetails(codeIds: string[]): Observable<CatalogueCode[]> {
        return this.http.post<CatalogueCode[]>(`${this.apiPath}picker/detail`, codeIds);
    }

    public loadUoMsByCodeName(codeName: string): Observable<CodeUoM[]> {
        return this.http.get<CodeUoM[]>(this.pickerAPI + 'code/uom/' + codeName);
    }

    // public loadBySubCategory(path: string, excludePricebook: string, isCodeItem: boolean, paging?: PagingOptions, excludeTypes?: CodeType[]): Observable<Code[]> {
    public loadBySubCategory(request: GetCodeCategoryEntitiesRequest): Observable<Code[]> {

        // const request = {
        //     category: path,
        //     isCodeItem: isCodeItem,
        //     excludePricebook: excludePricebook ?? '',
        //     paging: paging,
        //     excludeTypes: excludeTypes
        // } as GetCodeCategoryEntitiesRequest;

        return this.http.post<Code[]>(`${this.apiPath}category`, request);
    }

    public searchCodes(filter: string, itemOnly: boolean, excludeTypes?: CodeType[], purchaseAble?: boolean): Observable<CatalogueCode[]> {
        const request = { filter, itemOnly, excludeTypes } as any;

        if (!!purchaseAble) {
            request.purchaseAble = true;
        }

        return this.http.post<Code[]>(`${this.apiPath}filter`, request)
    }
}